import * as React from 'react';

import * as style from './style.css';
import { VerticalSlider } from '../VerticalSlider';
import { LeftArrow, RightArrow } from '../VerticalSlider/parts';

export interface IRatingTagsSliderProps {
  children: React.ReactNode;
}

export const RatingTagsSlider: React.FC<IRatingTagsSliderProps> = ({ children }) => {
  return (
    <div className={style['container']}>
      <VerticalSlider rightArrow={RightArrow} leftArrow={LeftArrow} scrollOffset={0}>
        {children}
      </VerticalSlider>
    </div>
  );
};
